import { BaseStore } from "../extends/base-store";
import { FormService } from "../services/form.service";

export class ConfirmeStore extends BaseStore {
  private confirmeStore: FormService;

  /**
   * @author Jose Wilson Mulato
   * @description Se establese una copia del valor si o no
   */
  protected async GetService() {
    this.confirmeStore = new FormService(this.http);
    this.Data = ConfirmeStore.GetCopyDefault();
    return;
  }

  /**
   * Obtiene el valor por defecto de si
   */
  public static YES: string = 'S';
  public static NOT: string = 'N';

  static GetCopyDefault() {
    return [
      {
        Label: "Sí",
        Value: ConfirmeStore.YES
      },
      {
        Label: "No",
        Value: ConfirmeStore.NOT
      }
    ];
  }

  static GetCopySoloSi() {
    return [
      {
        Label: "Sí",
        Value: ConfirmeStore.YES
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/store/confirme-store.ts